import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject
} from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ClientRegisteredVendor,
  CompanyVendor,
  ExemptVendor,
  Vendor
} from 'src/app/classes/models';
import { VendorReview } from 'src/app/classes/models/vendor-review';
import { AddEditVendorReviewModalComponent } from 'src/app/modals/add-edit-vendor-review-modal/add-edit-vendor-review-modal.component';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyVendorService } from 'src/app/services/company-vendor.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-client-my-vendors-ratings',
  templateUrl: './client-my-vendor-ratings.component.html',
  styleUrls: ['./client-my-vendor-ratings.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientMyVendorRatingsComponent implements OnInit {
  private _cdr = inject(ChangeDetectorRef);

  constructor(
    private route: ActivatedRoute,
    private CompanyVendorService: CompanyVendorService,
    private ToastService: ToastService,
    private ModalService: NgbModal,
    private AuthService: AuthService
  ) {}

  CompanyId!: number;
  VendorId!: number;
  Vendor!: Vendor | ExemptVendor | ClientRegisteredVendor;
  VendorReviews!: VendorReview[];
  CompanyVendor!: CompanyVendor;
  overallVendorRating!: number;
  yourVendorRating?: VendorReview;
  currentVendorRating?: VendorReview;

  loadData() {
    const params: ParamMap = this.route.snapshot.paramMap;
    const VendorId = Number(params.get('VendorId')) || null;
    const ExemptVendorId = Number(params.get('ExemptVendorId')) || null;
    const ClientRegisteredVendorId =
      Number(params.get('ClientRegisteredVendorId')) || null;
    const userId = this.AuthService.getUserId();
    const companyVendorQueryObj = {
      attributes: JSON.stringify([
        'id',
        'CompanyId',
        'VendorId',
        'ExemptVendorId',
        'ClientRegisteredVendorId',
        'overallVendorRating'
      ])
    };
    const vendorQuery = {
      VendorReview: {
        User: {}
      }
    };

    if (VendorId) {
      Object.assign(companyVendorQueryObj, {
        VendorId,
        Vendor: JSON.stringify(vendorQuery)
      });
    }

    if (ExemptVendorId) {
      Object.assign(companyVendorQueryObj, {
        ExemptVendorId,
        ExemptVendor: JSON.stringify(vendorQuery)
      });
    }

    if (ClientRegisteredVendorId) {
      Object.assign(companyVendorQueryObj, {
        ClientRegisteredVendorId,
        ClientRegisteredVendor: JSON.stringify(vendorQuery)
      });
    }

    this.CompanyVendorService.getCompanyVendor(companyVendorQueryObj).subscribe(
      {
        next: (companyVendor: CompanyVendor) => {
          if (!companyVendor) {
            throw this.ToastService.addErrorToast(
              'Error',
              'Company Vendor record not found.',
              { returnError: true }
            );
          }
          const {
            Vendor,
            ExemptVendor,
            ClientRegisteredVendor,
            overallVendorRating
          } = companyVendor;
          this.CompanyVendor = companyVendor;

          if (Vendor) {
            this.Vendor = Vendor;
          }

          if (ExemptVendor) {
            this.Vendor = ExemptVendor;
          }

          if (ClientRegisteredVendor) {
            this.Vendor = ClientRegisteredVendor;
          }

          if (this.Vendor) {
            const { VendorReviews } = this.Vendor;
            if (VendorReviews) {
              this.VendorReviews = VendorReviews;
              this.yourVendorRating = VendorReviews.find(
                (vr) => vr.User!.id === userId
              );
              this.currentVendorRating =
                this.yourVendorRating || this.VendorReviews[0];
            }
          }

          if (overallVendorRating) {
            this.overallVendorRating = overallVendorRating;
          }
          this._cdr.markForCheck();
        }
      }
    );
  }

  addUpdateReview() {
    const modalRef = this.ModalService.open(AddEditVendorReviewModalComponent, {
      windowClass: 'static',
      centered: true,
      size: 'xl'
    });
    modalRef.componentInstance.yourVendorRating = this.yourVendorRating;
    modalRef.componentInstance.CompanyVendor = this.CompanyVendor;
    modalRef.closed.subscribe({
      next: (vendorReview: VendorReview) => {
        if (vendorReview) {
          this.loadData();
          this.ToastService.addSuccessToast(
            'Success',
            'Successfully updated review.'
          );
          this._cdr.markForCheck();
        }
      }
    });
  }

  changeCurrentVendorReview(vendorReview: VendorReview) {
    this.currentVendorRating! = { ...vendorReview };
    this._cdr.markForCheck();
  }

  ngOnInit(): void {
    this.loadData();
  }
}
